import { useMutation, useQueryClient } from '@tanstack/react-query';

import { usersKey } from '@pages/Users/services/useUsersInfiniteQuery';

import { apiClient } from '@services/apiClient';
import { userProfileKey } from '@services/user/useUserProfileQuery';
import { userKey } from '@services/user/useUserQuery';

import { userFullProfileKey } from './useUserFullProfileQuery';

const userUpdateFn = (data) => apiClient.post(`${APP_SSO_URL}api/user/update`, data);

export const useUserUpdateMutation = ({ userId }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: userUpdateFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [usersKey()[0]] });
      queryClient.invalidateQueries({ queryKey: userProfileKey() });
      queryClient.invalidateQueries({ queryKey: userFullProfileKey() });
      queryClient.invalidateQueries({ queryKey: userKey(userId) });
    },
  });
};
